import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCsv = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M10.852 13.713H18v2.837h-7.15v-2.837Zm-8.852 0h7.149v2.837H2zm0-5.106h7.149v2.837H2zm8.852 0H18v2.837h-7.15V8.607Zm0-5.107H18v2.837h-7.15V3.5ZM2 3.5h7.149v2.837H2z" />
  </svg>
);
export default SvgCsv;
